import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import unleash from '../unleash';

const initialState = {
  isReady: false,
  isReadyPending: false,
};

export const startUnleash = createAsyncThunk('unleash/start', () => unleash.start());

const unleashSlice = createSlice({
  name: 'unleash',
  initialState,
  extraReducers: {
    [startUnleash.pending](state) {
      state.isReadyPending = true;
    },
    [startUnleash.fulfilled](state) {
      state.isReady = true;
      state.isReadyPending = false;
    },
    [startUnleash.rejected](state) {
      state.isReady = true; // if something happens with unleash we still assume it's ready (to not block the app)
      state.isReadyPending = false;
    },
  },
});

export default unleashSlice.reducer;
